/* eslint-disable */
import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { select } from '@angular-redux/store';
import { ApplicationActions } from '../../actions/application.actions';
import { FlowManagerService } from '../../shared/services/flowmanager.service';
import { AppSteps, QuestionnaireSteps } from '../../shared/models/Enum/ProgressBarSteps';
import template from './progress-bar.component.html';
import styles from './progress-bar.component.scss';

@Component({
  selector: 'ola-progress-bar',
  template,
  styles: [styles]
})
export class ProgressBarComponent {
  @select(['applicationStore', 'StepCompleted']) appState$;
  @select(['applicationStore', 'progressBar']) progressBar$;
  @ViewChild('focusItem') focusItem;
  @ViewChild('focusItemMobile') focusItemMobile;
  @Input() stepsRoute;

  constructor(
    appActions: ApplicationActions,
    flowManager: FlowManagerService,
    router: Router) {
    this.appActions = appActions;
    this.flowManager = flowManager;
    this.router = router;
    this.expanded = false;
    this.hasFunded = false;
    this.hasACHProfile = false;
  }

  ngOnInit() {
    this.subscriptions = [this.observeProgressBar()];
    if (this.stepsRoute === 'app') this.subscriptions.push(this.observeFunding());
    this.stepsArr = this.stepsRoute === 'questionnaire' ? QuestionnaireSteps : AppSteps;
    this.stepMax = this.stepsRoute === 'questionnaire' ? 3 : 5;
  }

  observeFunding() {
    return this.appState$.subscribe(data => {
      if (data) {
        this.hasACHProfile = data.achProfile || false;
        this.hasFunded = data.achTransfer || false;
        if (this.hasFunded) this.stepsArr[3].route = null;
      }
    });
  }

  observeProgressBar() {
    return this.progressBar$.subscribe(data => {
      this.loaded = data;

      if (data) {
        const { userOnStep, hasCompletedStep, expanded } = data;
        this.hasCompletedStep = hasCompletedStep || 0;
        this.expanded = expanded || false;
        this.userOnStep = userOnStep || -1;

        if ((this.stepsRoute === 'app' || this.stepsRoute === 'home')
          && this.stepMax === 5 && this.flowManager.isAuthed) {
          // Remove Enroll button is user is authed
          this.stepsArr = this.stepsArr.filter(step => step.num !== 5);
          this.stepMax = 4;
        }

        if (this.stepsRoute === 'app') {

          if (this.hasCompletedStep === 2 && !this.stepsArr[1].route) {
            this.stepsArr[1].route = this.flowManager.isAuthed
              ? 'personal-info-auth'
              : 'personal-info';

          } else if (this.hasCompletedStep === 3) { // Disable pre-submit step buttons after submit
            this.stepsArr[0].route = null;
            this.stepsArr[1].route = null;
            this.stepsArr[2].route = null;
          } else if (this.hasCompletedStep === 4) { // Funding button logic
            let fundingRoute = null;

            if (!this.hasFunded) {

              if (!this.hasACHProfile) {
                fundingRoute = this.flowManager.hasDepositAccounts ? 'funding-choices-streamline' : 'funding-choices';
              } else {
                fundingRoute = this.flowManager.isIra ? 'deposit-funds-ira' : 'deposit-funds';
              }
            }
            this.stepsArr[3].route = fundingRoute;
          }
        }

        if (this.userOnStep !== userOnStep) {
          if (window.innerWidth > 768 && this.focusItem) {
            this.focusItem.nativeElement.focus();
          } else if (window.innerWidth < 769 && this.focusItemMobile) {
            this.focusItemMobile.nativeElement.focus();
          }
        }

        if (this.userOnStep !== userOnStep) {
          if (window.innerWidth > 768 && this.focusItem) {
            this.focusItem.nativeElement.focus();
          } else if (window.innerWidth < 769 && this.focusItemMobile) {
            this.focusItemMobile.nativeElement.focus();
          }
        }
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  stepItemClick(url) {
    if (!url) return;
    this.router.navigate([url], { queryParamsHandling: 'preserve' });
  }

  toggleProgressBar() {
    this.appActions.setData('progressBar.expanded', !this.expanded);
  }
}
